import { Breadcrumb, Layout, Menu } from 'antd';
import React, { useCallback } from 'react';
import { MenuItem, OSLayoutProps } from '../../types';
import HeaderPage from './Header';
import './style.scss';

const { SubMenu } = Menu;
const { Content, Footer, Sider } = Layout;

const ThemeLayout = ({
  children,
  footer,
  navItems = [],
  onRenderMenuCreateItem,
  onRenderItem,
  headerConfig,
  onRenderItemHeader,
  hiddenNav,
  breadcrumb,
}: OSLayoutProps) => {
  const renderItem = useCallback((item: MenuItem) => {
    const { key, title } = item;
    return <Menu.Item key={key}>{onRenderItem?.(item) || title}</Menu.Item>;
  }, []);

  return (
    <Layout>
      <HeaderPage
        headerConfig={headerConfig}
        onRenderItemHeader={onRenderItemHeader}
        onRenderMenuCreateItem={onRenderMenuCreateItem}
      />
      <Content style={{ padding: '0 20px' }}>
        {breadcrumb?.length && (
          <Breadcrumb style={{ margin: '16px 0' }}>
            {breadcrumb.map((item) => (
              <Breadcrumb.Item key={item}>{item}</Breadcrumb.Item>
            ))}
          </Breadcrumb>
        )}
        <Layout
          className="site-layout-background"
          style={{ padding: '24px 0' }}
        >
          {!hiddenNav && (
            <Sider className="site-layout-background" width={200}>
              <Menu
                mode="inline"
                defaultSelectedKeys={['1']}
                defaultOpenKeys={['sub1']}
                style={{ height: '100%' }}
              >
                {navItems.map((item) => {
                  const { key, icon, submenu = [], title } = item;
                  if (submenu.length > 0) {
                    return (
                      <SubMenu key={key} icon={icon} title={title}>
                        {submenu?.map((sub) => renderItem(sub))}
                      </SubMenu>
                    );
                  }
                  return renderItem(item);
                })}
              </Menu>
            </Sider>
          )}
          <Content style={{ padding: '0 24px', minHeight: 280 }}>
            {children}
          </Content>
        </Layout>
      </Content>
      <Footer style={{ textAlign: 'center' }}>
        {footer ? footer : 'Civil Activity Request ©2021 Created by OSCAR Team'}
      </Footer>
    </Layout>
  );
};

export default ThemeLayout;
